import React from 'react'
import { Link } from 'react-router-dom'

const Card = ({title, children,link}) => {
  return (
    <Link to={`/${link}`} className="block">
      <div className="bg-white rounded-xl shadow-md hover:shadow-xl transition-all duration-300 transform hover:scale-105 p-4 h-full hover:ring-2 hover:ring-blue-400">
        <h3 className="text-xs font-semibold text-gray-600 uppercase tracking-wide mb-2">{title}</h3>
        <div className="flex items-center justify-between">
          {children}
        </div>
      </div>
    </Link>
  )
}

export default Card
